module.exports = __webpack_public_path__ + "static/media/modis2916.08c49012.jpg";